import { HeroId, Player } from '../types';

/**
 * Gets the effective hero for a player, accounting for Verisk's copy ability.
 * 
 * Verisk's ability: Copy the opponent's hero ability.
 * - If player is Verisk and opponent is NOT Verisk: Use opponent's hero
 * - If both are Verisk: No abilities for either (returns 'VERISK')
 * - Otherwise: Use player's own hero
 * 
 * @param player The player whose effective hero to determine
 * @param opponent The opponent player
 * @returns The hero ID whose abilities the player should use
 */
export const getEffectiveHero = (player: Player, opponent: Player): HeroId => {
    if (player.hero === 'VERISK') {
        // Verisk vs Verisk = no abilities (both return 'VERISK')
        if (opponent.hero === 'VERISK') {
            return 'VERISK';
        }
        // Verisk copies opponent's hero
        return opponent.hero;
    }
    // Normal case: use own hero
    return player.hero;
};
